import styled from "styled-components";
import {Select, Row, Table, Col, Input, Button} from "antd";
import {CloseOutlined} from "@ant-design/icons";
export const SelectField = styled(Select)`
    width: 100%;
    margin-bottom: 20px;
    @media (max-width: 768px) {
        display: flex;
        width: 100%;
        .ant-select-selector {
            min-width: 197px;
            font-size: 12px;
        }
    }
`;

export const SearchInput = styled(Input.Search)`
    @media (max-width: 768px) {
        min-width: 235px;
    }
    .ant-input-group-addon {
        bottom: 3px;
        background-color: transparent;
    }
`;

export const AllCouriersBusyInput = styled(Input)``;

export const CloseIcon = styled(CloseOutlined)`
    cursor: pointer;
`;

export const OptionsRow = styled(Row)`
    @media (max-width: 768px) {
        width: 100%;
        heigh: 100%;
    }
`;

export const TableContainer = styled(Table)`
    @media (max-width: 768px) {
        .ant-table-cell {
            font-size: 11px;
            padding: 1px;
        }
        .ant-tag {
            font-size: 10px;
            padding: 1px;
            margin: 0px;
        }
        .ant-btn-icon-only {
            font-size: 2px;
            width: 0px;
            height: 0px;
        }
        .daSDBY {
            margin: 0px;
        }
        .evcfTQ {
            margin: 0px;
        }
        .ant-table.ant-table-small .ant-table-tbody > tr > td,
        .ant-table.ant-table-small .ant-table-thead > tr > th {
            padding: 3px 3px;
        }
    }
`;

export const ColIcon = styled(Col)`
    @media (max-width: 768px) {
        .ant-badge-status-dot {
            display: none;
            width: 0px;
            height: 0px;
        }
    }
`;

export const AllBusyButton = styled(Button)`
    position: absolute;
    bottom: 21px;
`;

export const BusyRow = styled(Row)`
    margin-top: 16px;
    margin-bottom: 16px;
`;
